<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、
          <a @click="to(item)">普通合同</a>
        </span>
        <span v-else>普通合同</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <span style="display: block; padding-left: 16px;">
            <span class="desc">类型：{{ dictionaries.trade_contract_type[item.type] }}</span>
            <span class="desc">业务号：{{ item.business_no }}</span>
            <span class="desc">合同号：{{ item.contract_number }}</span>
            <span class="desc">合同名称：{{ item.contract_name }}</span>
            <span class="desc" v-if="item.client">客户：{{ item.client }}</span>
            <span class="desc" v-if="item.pricing_currency">计价币种：{{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}</span>
            <span class="desc" v-if="item.storage_location">储存地：{{ item.storage_location }}</span>
            <span class="desc" v-if="item.warehouse_manager">库管方：{{ item.warehouse_manager }}</span>
            <span class="desc" v-if="item.lease_start_date !== '1970-01-01' && item.lease_end_date">仓储租赁期限：{{ item.lease_start_date }} ~ {{ item.lease_end_date }}</span>
            <span class="desc" v-if="item.payment_method">支付方式：{{ dictionaries.trade_payment_method[item.payment_method] }}</span>
            <span class="desc" v-if="item.billing_method">计费方式：{{ item.billing_method }}</span>
            <span class="desc" v-if="item.payment_cycle">支付周期：{{ item.payment_cycle }}</span>
            <span class="desc" v-if="item.storage_location">存放地：{{ item.storage_location }}</span>
            <span class="desc" v-if="item.insurance_company">保险公司名称：{{ item.insurance_company }}</span>
            <span class="desc" v-if="item.insurance_type">保险险别：{{ item.insurance_type }}</span>
            <span class="desc" v-if="item.free_limit">免费额规定：{{ item.free_limit }}</span>
            <span class="desc" v-if="item.shipping_company">运输公司名称：{{ item.shipping_company }}</span>
            <span class="desc" v-if="item.demurrage_terms">滞期费规定：{{ item.demurrage_terms }}</span>
            <span class="desc" v-if="item.despatch_terms">速遣费规定：{{ item.despatch_terms }}</span>
            <span class="desc" v-if="item.free_demurrage_days">免堆期：{{ item.free_demurrage_days }} 天</span>
            <span class="desc" v-if="item.inspection_company">商检公司名称：{{ item.inspection_company }}</span>
            <span class="desc" v-if="item.inspection_items">检验事项：{{ item.inspection_items }}</span>
            <span class="desc" v-if="item.freight_forwarder_company">货代公司名称：{{ item.freight_forwarder_company }}</span>
            <span class="desc" v-if="item.loading_supervision_company">监装公司名称：{{ item.loading_supervision_company }}</span>
            <span class="desc" v-if="item.supervision_company">监管公司名称：{{ item.supervision_company }}</span>
            <span class="desc" v-if="item.service_content">服务内容：{{ item.service_content }}</span>
            <span class="desc" v-if="item.business_type">业务类型：{{ dictionaries.trade_contract_business_type[item.business_type] }}</span>

            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_contract', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'contract')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
            <span class="desc" v-if="item.version === 1">版本：V{{ item.version }}</span>
            <span class="desc" v-else-if="item.version > 1" @click="showContractDiffView(item)">版本：<a>V{{ item.version }}</a></span>
            <contract-record :contractRecordList="contractRecordList" v-if="contractRecordVisible" :visible="contractRecordVisible" @close="contractRecordVisible=false"/>
          </span>
          <span style="padding-left: 16px;" class="desc" v-if="item.remark">备注：{{ item.remark }}</span>
          <div style="padding-left: 16px;" v-if="!item.is_archived && ((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)) && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'contract')" v-if="!item.is_approval_needed && !item.is_expired">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'contract')">
                <span v-if="(item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)">删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_contract', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div v-if="item.attachment !== undefined && item.attachment.filter(i => i.file_type === 1).length > 0">
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="附件" :style="customStyle">
                <a v-for="(attachment) in item.attachment.filter(i => i.file_type === 1)" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
          <div v-if="item.attachment !== undefined && item.attachment.filter(i => i.file_type === 2).length > 0">
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="发票其他文件" :style="customStyle">
                <a v-for="(attachment) in item.attachment.filter(i => i.file_type === 2)" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import ContractRecord from '../modules/ContractRecord'

export default {
  name: 'ContractInfo',
  components: {
    ContractRecord
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tradeType () {
      return (trade_type) => {
        switch (trade_type) {
          case 1:
            return '内贸'
          case 2:
            return '进口'
          case 3:
            return '出口'
        }
      }
    },
    futuresContractPreTitle () {
      return (index) => {
        if (index === 0) {
          return ''
        } else if (index === 1) {
          return '转月后'
        } else if (index === 2) {
          return '二次转月后'
        } else {
          return (index + 1) + '次转月后'
        }
      }
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      recordVisible: false,
      contractRecordVisible: false,
      contractRecordList: [],
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    to (item) {
      let path
      if (item.type === 1) {
        path = '/trade/storage_contract'
      } else if (item.type === 2) {
        path = '/trade/freight_forwarding_contract'
      } else if (item.type === 3) {
        path = '/trade/charter_party_contract'
      } else if (item.type === 4) {
        path = '/trade/booking_contract'
      } else if (item.type === 6) {
        path = '/trade/inspection_contract'
      } else if (item.type === 7) {
        path = '/trade/loading_supervision_contract'
      } else if (item.type === 9) {
        path = '/trade/insurance_contract'
      } else if (item.type === 10) {
        path = '/trade/supervision_contract'
      } else if (item.type === 12) {
        path = '/trade/guarantee_contract'
      }
      this.$router.push({ path: path, query: { id: item.id } })
    },
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    },
    showContractDiffView (item) {
      this.contractRecordVisible = !this.contractRecordVisible
      if (this.contractRecordVisible) {
        this.contractRecordList = item.contract_record_list
      }
    },
    closeDrawer () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
